import { render, staticRenderFns } from "./AdminSubcategories.vue?vue&type=template&id=7e679c16"
import script from "./AdminSubcategories.vue?vue&type=script&lang=js"
export * from "./AdminSubcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e679c16')) {
      api.createRecord('7e679c16', component.options)
    } else {
      api.reload('7e679c16', component.options)
    }
    module.hot.accept("./AdminSubcategories.vue?vue&type=template&id=7e679c16", function () {
      api.rerender('7e679c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminSubcategories.vue"
export default component.exports